module.exports = __webpack_public_path__ + "img/enableOpenProjectInfo_02.e69b9b9c.png";